import React from 'react';


import Backdrop from './Backdrop';

import styled from 'styled-components';


const Spinner = styled.div`
    width: 10%;
    height: 10%;
    position: fixed;
    z-index: 70000;
    box-sizing: border-box;
    padding: 10px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 35%;
    left: calc(45%);
`
const Loader = styled.div`
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #F97A7A;
    border-right: 5px solid #F97A7A;
    border-bottom: 5px solid #F97A7A;
    width: 40px;
    height: 40px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
`
const spinnerModal = (props) => (
   <div>
     <Backdrop show={props.show} />
     <Spinner
     style={{
        transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.show ? '1': '0'

    }}
     >
       <Loader />
    </Spinner>
   </div>
);

export default spinnerModal;